import styled from '@emotion/styled';
import { Theme } from '@silvertours/front-shared';

export const ContentModuleSegment = styled.div<{
  bottomMargin: 'default' | 'small';
}>`
  margin-bottom: ${({ bottomMargin, theme }) =>
    bottomMargin === 'small' ? theme.spacing[30] : theme.spacing[120]};

  ${Theme.mq('sm')} {
    margin-bottom: ${({ bottomMargin, theme }) =>
      bottomMargin === 'small' ? theme.spacing[40] : theme.spacing[140]};
  }

  &:last-child {
    margin-bottom: 0;
  }
`;
